<template>
  <div class="ml-6 mr-6 mt-2" :style="navbarWithName ? 'margin-left: 155px !important; margin-right: auto !important;' : ''">
    <v-alert v-if="alert" class="mb-3" border="top" :color="colorAlert" dark>
      {{ message }}
    </v-alert>

    <v-layout
      :class="{
        'd-flex ma-0 pa-0 ml-1 justify-center': (showDateStart == '' && showDateEnd == '') || (showDateStart != '' && showDateEnd != '' && isShowDate == false),
        'd-flex ma-0 pa-0 ml-1': showDateStart != '' && showDateEnd != '' && isShowDate == true
      }"
      row
      wrap
    >
      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="topicSentiment"
          item-text="TOPIC"
          item-value="SEQ_ID"
          v-model="selectedTopic"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Topic"
          no-data-text="No topic available"
          dense
          outlined
          rounded
          @change="selectedPortal = '', selectedPortalId = '', parameterProsesTopic()"
        ></v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
        <v-select
          :items="topicKeywordSentiment"
          v-model="selectedKeyword"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Keyword"
          no-data-text="No keyword available"
          dense
          outlined
          rounded
          @change="parameterProsesKeyword"
        ></v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="periodeBerita"
          item-text="name"
          item-value="value"
          v-model="selectedPeriode"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Periode"
          dense
          outlined
          rounded
          @change="parameterProsesPeriode"
        >
          <template v-slot:append-item>
            <v-list-item>
              <v-list-item-title>
                <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" small dark width="120" color="var(--color-theme)">
                      Custom
                    </v-btn>
                  </template>
                  <v-card>
                    <v-row class="pa-8" justify="space-around">
                      <v-date-picker
                        v-model="dateStart"
                        :show-current="false"
                        class="custom-date-picker"
                        color="var(--color-theme)"
                        @change="showPeriodeDate"
                      ></v-date-picker>
                      <v-date-picker
                        v-model="dateEnd"
                        :show-current="false"
                        class="ml-8 custom-date-picker"
                        color="var(--color-theme)"
                        @change="showPeriodeDate"
                      ></v-date-picker>
                    </v-row>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#000" text @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn color="var(--color-theme)" text @click="menu = false, parameterProsesCustom()">
                        Set
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-select>
      </v-col>

      <v-col
        v-if="showDateStart != '' && showDateEnd != ''"
        class="d-flex ma-0 pa-0 mx-3"
        cols="12"
        sm="3"
      >
        <v-card style="border-radius: 30px; width: 100%;" height="40" outlined>
          <v-card-text class="pa-2 px-4">
            <v-icon>mdi-calendar</v-icon>
            <span class="mt-2 ml-1">
              {{ showDateStart[1] + " " + showDateStart[0] + " " + showDateStart[2] }} - {{ showDateEnd[1] + " " + showDateEnd[0] + " " + showDateEnd[2] }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        :class="{
          'd-flex ma-0 pa-0 ml-3': (showDateStart == '' && showDateEnd == '') || (showDateStart != '' && showDateEnd != '' && isShowDate == false),
          'd-flex ma-0 pa-0': showDateStart != '' && showDateEnd != '' && isShowDate == true
        }"
        cols="12"
        sm="1"
      >
        <v-btn
          color="var(--color-theme-secondary)"
          style="max-width: 100%;"
          height="40"
          dense
          dark
          rounded
          block
          @click="isSearch = true, loadMediaShare()"
        >
          <v-icon>mdi-magnify</v-icon>
          Search
        </v-btn>
      </v-col>

      <v-col
        class="d-flex ma-0 pa-0 ml-3"
        cols="12"
        sm="1"
      >
        <v-btn
          v-if="isColorThemeSetneg"
          color="var(--color-theme)"
          style="max-width: 100%;"
          height="40"
          outlined
          rounded
          block
          @click="dialogConfirmReset = true"
        >
          <v-icon>mdi-reload</v-icon>
          Reset
        </v-btn>

        <v-btn
          v-else
          class="white--text"
          style="max-width: 100%;"
          height="40"
          color="#a80202"
          variant="outlined"
          rounded
          block
          @click="dialogConfirmReset = true"
        >
          <v-icon>mdi-reload</v-icon>
          Reset
        </v-btn>
      </v-col>

      <v-col
        :class="{
          'd-flex ma-0 pa-0 ml-3': (showDateStart == '' && showDateEnd == '') || (showDateStart != '' && showDateEnd != '' && isShowDate == false),
          'd-flex ma-0 pa-0': showDateStart != '' && showDateEnd != '' && isShowDate == true
        }"
        cols="12"
        sm="1"
      >
        <v-btn
          color="var(--color-theme)"
          style="max-width: 100%;"
          height="40"
          outlined
          rounded
          block
          @click="isCapture = true, captureAll()"
        >
          <v-icon>mdi-content-cut</v-icon>
          Capture
        </v-btn>
      </v-col>
    </v-layout>

    <div class="mb-8 d-flex justify-end">
      <v-btn
        class="d-flex align-center justify-space-between pa-0 px-2"
        :style="{
          position: 'fixed',
          bottom: '60px',
          right: '30px',
          'z-index': (dialogLoading || dialogSearchContext) ? 1 : 9999,
          'border-radius': '9999px'
        }"
        height="50"
        width="165"
        color="white"
        elevation="4"
        @click="insightAIassistant()"
      >
        <div
          class="d-flex align-center justify-center"
          :style="{ backgroundColor: 'var(--color-theme)', borderRadius: '50%', width: '36px', height: '36px' }"
        >
          <SparklesIcon class="w-4 h-4" style="color: white;" />
        </div>

        <div style="flex: 1; text-align: center;">
          <span style="text-transform: none; color: black; font-size: 14px;">
            Insights AI
          </span>
        </div>

        <v-icon
          :style="{
            'margin-top': dialogPageInsight ? '-3px' : '1px',
            transform: dialogPageInsight ? 'rotate(90deg)' : 'rotate(-90deg)',
            transition: 'transform 0.2s ease',
            color: 'black'
          }"
          size="18"
        >
          mdi-play
        </v-icon>
      </v-btn>
    </div>

    <v-layout row wrap>
      <v-flex lg12>
        <v-card class="mx-5 mb-6 rounded-lg pa-4" height="auto" flat>
          <div class="mt-2 ml-4 font-weight-medium" style="font-size: 22px;">
            Periodic Media Content
          </div>
          <div class="ml-4 grey--text" style="font-size: 15px;">
            Cross-Portal Data Volume Over Time
          </div>

          <apexcharts
            :options="sentimentAnalysis"
            :series="seriesSentiment"
            class="mt-4 py-4"
            type="area"
            width="100%"
            height="360px"
          ></apexcharts>
          <v-row
            v-for="(rowItems, rowIndex) in rowListPortalDomain"
            :key="rowIndex"
            dense
            class="mt-1 justify-center mb-4"
          >
            <v-col
              v-for="item in rowItems"
              :key="item.id"
              cols="12"
              sm="6"
              md="4"
              lg="2"
              class="d-flex justify-center"
            >
              <v-btn
                :style="{
                  backgroundColor: selectedPortalId === item.id ? '#e1f2fa' : '#fff',
                  width: '185px',
                  color: '#0471A5',
                  borderRadius: '8px',
                  boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px',
                  height: '80px',
                  marginTop: '10px'
                }"
                color="#fff"
                x-large
                @click="
                  if (selectedPortalId === item.id) {
                    selectedPortalId = '';
                    selectedPortal = '';
                    changeBackgroundColor = false;
                  } else {
                    selectedPortalId = item.id;
                    selectedPortal = item.name;
                    changeBackgroundColor = true;
                  }
                  loadDataBySelectedPortal(item.name);
                "
              >
                <v-card-text>
                  <v-avatar v-if="item.PRS_IMAGE == `${urlLogoPortalDomain}upload/news/`" class="color-avatar-berita-online" style="margin-top: 3px" size="36">
                    <v-icon class="white--text">
                      {{ item.icon }}
                    </v-icon>
                  </v-avatar>
                  <h5 v-if="item.PRS_IMAGE == `${urlLogoPortalDomain}upload/news/`" class="text--teal darken-2 text-center">
                    {{ item.name }}
                  </h5>
                  <img v-else :src="item.PRS_IMAGE" height="30" width="100" />
                  <h2 class="text--teal darken-2 text-center">
                    {{ item.total }}
                    <span style="font-size: 16px; font-weight: 400;">
                      ({{ totalCollectedData ? Math.round((item.total / totalCollectedData) * 100) : 0 }}%)
                    </span>
                  </h2>
                </v-card-text>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-flex>

      <v-flex lg12 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'mx-5 mb-6 rounded-lg pa-4' : 'mx-4 mb-6 rounded-lg pa-4'" height="500px" flat>
          <div ref="clusterAnalysisCard">
            <v-card-title>
              <div>
                <div class="ml-1 font-weight-medium" style="font-size: 22px;">
                  Cluster Analysis
                </div>
                <div class="ml-1 grey--text" style="font-size: 15px; font-weight: 400;">
                  Thematic Content Grouping
                </div>
              </div>

              <v-spacer></v-spacer>
              <div class="mr-2 d-flex flex-column align-end">
                <v-btn
                  class="white--text"
                  color="#a80202"
                  variant="outlined"
                  rounded
                  @click="zoomOut"
                >
                  <v-icon left>mdi-reload</v-icon>
                  Reset Zoom
                </v-btn>

                <div class="mt-2 grey--text text-caption" style="font-size: 14px !important;">
                  This analysis has been calculated on {{ lastCalculatedOn }}
                </div>
              </div>
            </v-card-title>

            <FoamTreeComponent ref="clustercarot"></FoamTreeComponent>
          </div>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout style="margin-left: 2px; margin-right: -4px;" row wrap>
      <v-flex lg6>
        <v-card class="card-container mr-3 mb-6 rounded-lg pa-4" height="640" flat>
          <v-row class="ma-2 pa-0 ml-0 mx-0 ma-0">
            <v-flex lg12 sm12 md12 xs12>
              <v-card class="mx-4 mb-6 rounded-lg pa-4" :style="navbarWithName ? 'width: 400px;' : ''" height="575px" flat>
                <div ref="entityBubbleCard">
                  <div class="font-weight-medium" style="font-size: 22px;">
                    Entity Bubble
                  </div>
                  <div class="mb-4 grey--text" style="font-size: 15px;">
                    Entity Sentiment Deep Dive
                  </div>
                  <v-row class="justify-end mb-2" no-gutters>
                    <v-btn
                      :class="selectedEntity == 'Person' ? 'blue white--text' : 'grey white--text'"
                      small
                      @click="changeEntity('Person')"
                    >
                      Person
                    </v-btn>
                    <v-btn
                      :class="selectedEntity == 'Organization' ? 'blue white--text ml-2' : 'grey ml-2 white--text'"
                      small
                      @click="changeEntity('Organization')"
                    >
                      Organization
                    </v-btn>
                    <v-btn
                      :class="selectedEntity == 'Location' ? 'blue white--text ml-2' : 'grey ml-2 white--text'"
                      small
                      @click="changeEntity('Location')"
                    >
                      Location
                    </v-btn>
                  </v-row>
                  <div class="mt-10 bubble-container">
                    <div
                      v-for="(entity, index) in entities"
                      :key="index"
                      class="bubble d-flex align-center justify-center"
                      :style="{
                        width: entity.size + 'px',
                        height: entity.size + 'px',
                        top: entity.top + 'px',
                        left: entity.left + 'px',
                        position: 'absolute',
                        borderRadius: '50%',
                        backgroundColor: selectedEntity == 'Location'
                          ? backgroundColorLocation[index % backgroundColorLocation.length]
                          : '#fff',
                        overflow: 'hidden',
                        textAlign: 'center',
                        cursor: 'pointer'
                      }"
                      @mouseenter="showTooltip(entity, $event)"
                      @mousemove="moveTooltip($event)"
                      @mouseleave="hideTooltip"
                      @click="loadContentByEntity(entity.nameOriginal, entity.totPositive, entity.totNegative, entity.totNeutral)"
                    >
                      <template v-if="selectedEntity == 'Location'">
                        <span style="padding: 4px; font-size: 12px; color: #000;">
                          {{ entity.name }}
                        </span>
                      </template>
                      <template v-else>
                        <img
                          :src="entity.image || (selectedEntity == 'Person' ? 'default-person.png' : 'default-organization.png')"
                          :alt="entity.name"
                          class="bubble-image"
                          style="width: 100%; height: 100%; object-fit: cover;"
                        />
                      </template>
                    </div>

                    <div
                      v-if="tooltip.visible"
                      :style="{ top: tooltip.top + 'px', left: tooltip.left + 'px' }"
                      class="tooltip-entity-bubble"
                    >
                      <b style="font-size: 16px;">{{ tooltip.data.name }}</b><br />
                      {{ tooltip.data.contents }} contents<br />
                      <div style="margin-top: 8px; background-color: white !important;">
                        Detected in contents from <b>{{ tooltip.data.sources }}</b> online media,
                        with <b>{{ tooltip.data.positive }}%</b> positive sentiment,
                        <b>{{ tooltip.data.negative }}%</b> negative sentiment,
                        and <b>{{ tooltip.data.neutral }}%</b> neutral sentiment.
                      </div>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-flex>
          </v-row>
        </v-card>
      </v-flex>

      <v-flex lg6>
        <v-card class="card-container mr-3 mb-6 rounded-lg pa-4" height="640" flat>
          <v-card class="mx-4 rounded-lg pa-4" :style="navbarWithName ? 'width: 400px;' : ''" height="615px" flat>
            <div class="mt-2 ml-1 font-weight-medium" style="font-size: 22px;">
              Content List
            </div>
            <div class="ml-1 mb-1 grey--text" style="font-size: 15px;">
              Filtered Content Display
            </div>
            <v-tabs v-model="selectedTab" :key="selectedTab" center-active color="#0471A5">
              <v-tab @click="contentListSentiment('Positive')">
                Positive
                <v-chip small class="ma-2" color="#0471A5" text-color="white">
                  {{ beritaPositivePersen }} % / {{ beritaPositive }} Data
                </v-chip>
              </v-tab>
              <v-tab class="ml-8" @click="contentListSentiment('Neutral')">
                Neutral
                <v-chip small class="ma-2" color="#0471A5" text-color="white">
                  {{ beritaNetralPersen }} % / {{ beritaNetral }} Data
                </v-chip>
              </v-tab>
              <v-tab class="ml-8" @click="contentListSentiment('Negative')">
                Negative
                <v-chip small class="ma-2" color="#1A8EC5" text-color="white">
                  {{ beritaNegativePersen }} % / {{ beritaNegative }} Data
                </v-chip>
              </v-tab>

              <v-tab-item style="background-color: #fff">
                <v-card class="elevation-0 overflow-card" height="475px">
                  <v-row class="ma-2">
                    <v-flex v-for="(item, index) in kontenBeritaPositive" :key="item.id" lg12>
                      <v-card
                        :href="item.url"
                        target="_blank"
                        flat
                        :class="{ 'rounded-lg content-list-card': index == 0, 'mt-2 rounded-lg content-list-card': index != 0 }"
                        style="border-radius: 8px; border: 0.6px solid #E4E4E4; background: #FFF;"
                      >
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <v-list-item three-line>
                            <v-list-item-content>
                              <v-list-item-title class="body-1" style="width: 300px; text-wrap: wrap;">
                                {{ item.title }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap;">
                                {{ item.content }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap; display: flex; flex-direction: column;">
                                <div class="d-flex align-center">
                                  <v-avatar
                                    v-if="getPrsImage(item.domain) == `${urlLogoPortalDomain}upload/news/`"
                                    class="color-avatar-berita-online"
                                    size="38"
                                  >
                                    <v-icon class="white--text" size="30">
                                      fa-thin fa-globe
                                    </v-icon>
                                  </v-avatar>
                                  <img
                                    v-else
                                    :src="getPrsImage(item.domain)"
                                    alt=""
                                    style="width: 38px; height: 38px; border-radius: 50%; object-fit: contain; background: #f0f0f0;"
                                  >
                                  <span class="ml-2" style="font-style: italic; font-size: 12px; color: #439EDF; overflow-wrap: break-word;">
                                    {{ item.url }}
                                  </span>
                                </div>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </div>
                      </v-card>
                    </v-flex>
                  </v-row>
                </v-card>
              </v-tab-item>

              <v-tab-item style="background-color: #fff">
                <v-card class="elevation-0 overflow-card" height="475px">
                  <v-row class="ma-2">
                    <v-flex v-for="(item, index) in kontenBeritaNetral" :key="item.id" lg12>
                      <v-card
                        :href="item.url"
                        target="_blank"
                        flat
                        :class="{ 'rounded-lg content-list-card': index == 0, 'mt-2 rounded-lg content-list-card': index != 0 }"
                        style="border-radius: 8px; border: 0.6px solid #E4E4E4; background: #FFF;"
                      >
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <v-list-item three-line>
                            <v-list-item-content>
                              <v-list-item-title class="body-1" style="width: 300px; text-wrap: wrap;">
                                {{ item.title }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap;">
                                {{ item.content }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap; display: flex; flex-direction: column;">
                                <div class="d-flex align-center">
                                  <v-avatar
                                    v-if="getPrsImage(item.domain) == `${urlLogoPortalDomain}upload/news/`"
                                    class="color-avatar-berita-online"
                                    size="38"
                                  >
                                    <v-icon class="white--text" size="30">
                                      fa-thin fa-globe
                                    </v-icon>
                                  </v-avatar>
                                  <img
                                    v-else
                                    :src="getPrsImage(item.domain)"
                                    alt=""
                                    style="width: 38px; height: 38px; border-radius: 50%; object-fit: contain; background: #f0f0f0;"
                                  >
                                  <span class="ml-2" style="font-style: italic; font-size: 12px; color: #439EDF; overflow-wrap: break-word;">
                                    {{ item.url }}
                                  </span>
                                </div>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </div>
                      </v-card>
                    </v-flex>
                  </v-row>
                </v-card>
              </v-tab-item>

              <v-tab-item style="background-color: #fff">
                <v-card class="elevation-0 overflow-card" height="475px">
                  <v-row class="ma-2">
                    <v-flex v-for="(item, index) in kontenBeritaNegative" :key="item.id" lg12>
                      <v-card
                        :href="item.url"
                        target="_blank"
                        flat
                        :class="{ 'rounded-lg content-list-card': index == 0, 'mt-2 rounded-lg content-list-card': index != 0 }"
                        style="border-radius: 8px; border: 0.6px solid #E4E4E4; background: #FFF;"
                      >
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <v-list-item three-line>
                            <v-list-item-content>
                              <v-list-item-title class="body-1" style="width: 300px; text-wrap: wrap;">
                                {{ item.title }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap;">
                                {{ item.content }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap; display: flex; flex-direction: column;">
                                <div class="d-flex align-center">
                                  <v-avatar
                                    v-if="getPrsImage(item.domain) == `${urlLogoPortalDomain}upload/news/`"
                                    class="color-avatar-berita-online"
                                    size="38"
                                  >
                                    <v-icon class="white--text" size="30">
                                      fa-thin fa-globe
                                    </v-icon>
                                  </v-avatar>
                                  <img
                                    v-else
                                    :src="getPrsImage(item.domain)"
                                    alt=""
                                    style="width: 38px; height: 38px; border-radius: 50%; object-fit: contain; background: #f0f0f0;"
                                  >
                                  <span class="ml-2" style="font-style: italic; font-size: 12px; color: #439EDF; overflow-wrap: break-word;">
                                    {{ item.url }}
                                  </span>
                                </div>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </div>
                      </v-card>
                    </v-flex>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card>
          <div v-if="tabsSentiment == 'Positive'" class="text-center">
            <v-pagination
              class="mt-4 my-2"
              v-model="pagePositive"
              :total-visible="8"
              :length="pageLengthPositive"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              @input="handlePageChangePositive"
            ></v-pagination>
          </div>
          <div v-if="tabsSentiment == 'Neutral'" class="text-center">
            <v-pagination
              class="mt-4 my-2"
              v-model="pageNetral"
              :total-visible="8"
              :length="pageLengthNetral"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              @input="handlePageChangeNetral"
            ></v-pagination>
          </div>
          <div v-if="tabsSentiment == 'Negative'" class="text-center">
            <v-pagination
              class="mt-4 my-2"
              v-model="pageNegative"
              :total-visible="8"
              :length="pageLengthNegative"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              @input="handlePageChangeNegative"
            ></v-pagination>
          </div>
        </v-card>
      </v-flex>

      <v-overlay v-model="overlayDialogLoading">
        <v-dialog v-model="dialogLoading" persistent max-width="290">
          <v-card>
            <v-card-title class="text-h6 font-weight-medium align-center justify-center">
              Page loading
            </v-card-title>
            <v-card-text class="body-1 align-center justify-center">
              {{ isCapture ? 'Loading capture, please wait' : 'Loading content, please wait' }}
            </v-card-text>
            <v-card-title class="align-center justify-center pt-2 pb-4">
              <v-progress-circular
                color="var(--color-theme)"
                :size="70"
                :width="7"
                indeterminate
              ></v-progress-circular>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="var(--color-theme)"
                text
                @click="overlayDialogLoading = false, dialogLoading = false"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-overlay>

      <v-dialog v-model="dialogSearchContext" height="500" width="350">
        <v-card class="pa-5" color="var(--color-theme-secondary)" rounded="lg" dark>
          <v-btn class="btn-close-dialog-search-context" icon @click="dialogSearchContext = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-card-text
            class="text-center"
            style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 20px;"
          >
            <h3 class="white--text mb-4">
              Keyword Search Results
            </h3>
            <p class="white--text">
              Topic: <strong>{{ searchContextTopic }}</strong>
              <br>
              From: <strong>{{ searchContextStartDate }}</strong> to <strong>{{ searchContextEndDate }}</strong>
            </p>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogConfirmReset" width="330px">
        <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
          <v-btn class="confirm-reset ma-0 pa-0" color="#aaa" small icon @click="dialogConfirmReset = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-avatar style="border: 2px solid #ddd;" color="#eee" size="80">
            <v-icon class="white--text" size="80">
              mdi-check
            </v-icon>
          </v-avatar>

          <h1 class="mt-2 text-center text-h6 align-center justify-center">
            Are you sure?
          </h1>

          <v-card-text class="align-center justify-center mt-2">
            Are you sure you want to reset?
          </v-card-text>

          <v-divider class="mt-4"></v-divider>

          <v-card-actions class="align-center justify-center">
            <v-btn
              color="#0471A5"
              width="120px"
              height="40px"
              style="borderRadius: 8px"
              size="large"
              dark
              outlined
              @click="dialogConfirmReset = false"
            >
              Cancel
            </v-btn>
            <v-btn
              class="my-3"
              width="120px"
              height="40px"
              style="borderRadius: 8px"
              color="#e30700"
              size="large"
              dark
              @click="
                dialogConfirmReset = false,
                selectedPortal = '',
                selectedPortalId = '',
                changeBackgroundColor = false,
                nerPersonSearch = '',
                nerOrganizationSearch = '',
                nerLocationSearch = '',
                loadTopic(),
                parameterProsesPeriode(),
                filterReset()
              "
            >
              Reset
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogPageInsight" attach="#floating-dialog-anchor" width="340" scrollable hide-overlay>
        <v-card style="position: fixed; bottom: 120px; right: 30px; border-radius: 12px; height: 460px; width: 60%" elevation="8">
          <v-card-title class="white--text" :style="{ backgroundColor: 'var(--color-theme)' }">
            <SparklesIcon class="w-4 h-4" style="color: white;" />
            <span class="ml-2 font-weight-bold">
              Insights AI Assistant
            </span>
            <v-spacer></v-spacer>
            <v-btn icon @click="regenerateInsight">
              <v-icon
                color="white"
                :class="{ 'rotate-animation': isRotatingRegenerateInsight }"
                style="transform: rotate(90deg);"
              >
                mdi-sync
              </v-icon>
            </v-btn>
            <v-btn icon @click="dialogPageInsight = false">
              <v-icon color="white">
                mdi-close
              </v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="mt-5" style="max-height: 345px; overflow-y: auto;">
            <div v-if="loadingResponseDescribeDashboard && listResponseDescribeDashboard.length == 0" class="loading-dots">
              <span>.</span><span>.</span><span>.</span>
            </div>

            <div
              v-if="
                !loadingResponseDescribeDashboard &&
                listResponseDescribeDashboard.length == 1 &&
                listResponseDescribeDashboard[0] == 'The server is busy. Please try again later.'
              "
            >
              <div class="d-flex justify-end">
                <div
                  class="response-textdescribedashboard rounded-lg"
                  style="width: 100%"
                  v-html="formatTextDescribeDashboard(listResponseDescribeDashboard[0])"
                ></div>
              </div>
            </div>

            <div v-else v-for="(item, index) in listResponseDescribeDashboard" :key="index" class="mb-2">
              <template v-if="currentLoadingIndex == index">
                <div class="loading-dots">
                  <span>.</span><span>.</span><span>.</span>
                </div>
              </template>
              <template v-else-if="currentLoadingIndex > index">
                <div class="d-flex justify-end">
                  <div
                    class="response-textdescribedashboard rounded-lg"
                    style="width: 100%"
                    v-html="formatTextDescribeDashboard(item)"
                  ></div>
                </div>
              </template>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogSuccessGenerateNewsletter"
        persistent
        max-width="330px"
      >
        <v-card
          class="text-center align-center justify-center pa-6 rounded-lg"
          width="330px"
        >
          <v-avatar
            color="var(--color-theme)"
            style="border: 2px solid var(--color-theme);"
            size="80"
          >
            <v-icon class="white--text" size="80">
              mdi-check
            </v-icon>
          </v-avatar>

          <h1 class="mt-2 text-center text-h6 align-center justify-center" style="text-wrap: wrap">
            Newsletter successfully generated
          </h1>

          <v-divider class="mt-4"></v-divider>

          <v-card-actions class="align-center justify-center">
            <v-btn
              color="var(--color-theme)"
              style="borderRadius: 8px"
              size="large"
              height="40px"
              width="120px"
              dark
              @click="dialogSuccessGenerateNewsletter = false"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div id="floating-dialog-anchor"></div>

      <div>
        <Notification ref="alert"></Notification>
      </div>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import VueApexCharts from 'vue-apexcharts';
import Notification from '@/components/Notification';
import { decryptionData, generateFilterDate, processTopicKeywords, encodeKeywordRequest, trackEvent } from '@/components/utils/utils.js';
import { mapGetters } from 'vuex';
import FoamTreeComponent from '@/components/ClusterCarrot';
import { SparklesIcon } from "@vue-hero-icons/solid";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export default {
  components: {
    apexcharts: VueApexCharts,
    Notification: Notification,
    FoamTreeComponent,
    SparklesIcon,
  },
  data: function() {
    return {
      base64HeaderSolusi247: null,
      clusterAnalysisInsights: "",
      entityInsights: "",
      dialogSuccessGenerateNewsletter: false,
      isCapture: false,
      isRotatingRegenerateInsight: false,
      listIndexOpenInsight: [ true ],
      indexOpenInsight: 0,
      dialogPageInsight: false,
      loadingResponseDescribeDashboard: false,
      listResponseDescribeDashboard: [],
      currentLoadingIndex: 0,
      chartSentimentPortal: "",
      sentimentAnalysis: {
        chart: {
          id: 'Memory Usage',
          background: 'transparent'
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val;
            },
          },
          x: {
            show: false,
          },
        },
        fill: {
          opacity: 1,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        colors: ['#45AF5B', '#FF1752', '#008FFB'],
        xaxis: {
          categories: [],
          labels: {
            style: {}
          }
        },
        yaxis: {
          labels: {
            style: {}
          }
        }
      },
      seriesSentiment: [],
      listPortalDomain: "",
      urlLogoPortalDomain: "",
      listPrsImageDomain: "",
      selectedPortalId: "",
      selectedPortal: "",
      changeBackgroundColor: false,
      totalCollectedData: 0,
      sentimentSearch: "",
      lastCalculatedOn: '-',
      selectedEntity: "Person",
      nerPersonSearch: "",
      nerOrganizationSearch: "",
      nerLocationSearch: "",
      entities: "",
      entitiesAll: "",
      backgroundColorLocation: ["gray", "pink", "yellow", "#3cb371", "#9370db", "#fc2e20", "lightblue", "#009CFF", "#ffa500", "purple"],
      tooltip: {
        visible: false,
        top: 0,
        left: 0,
        data: {}
      },
      selectedTab: 0,
      tabsSentiment: "Positive",
      kontenBeritaAll: [],
      kontenBeritaPositive: [],
      kontenBeritaNetral: [],
      kontenBeritaNegative: [],
      beritaPositivePersen: "",
      beritaNetralPersen: "",
      beritaNegativePersen: "",
      beritaPositive: "",
      beritaNetral: "",
      beritaNegative: "",
      pageplay: 100,
      pagePositive: 1,
      pageNetral: 1,
      pageNegative: 1,
      pageLengthPositive: "",
      pageLengthNetral: "",
      pageLengthNegative: "",
      selectedTopic: "",
      selectedKeyword: "",
      selectedPeriode: "This Week",
      topicSentiment: [],
      topicKeywordSentiment: [],
      periodeBerita: [
        { name: 'Today', value: 'Today' },
        { name: 'From Yesterday', value: 'From Yesterday' },
        { name: 'This Week', value: 'This Week' },
        { name: 'From Previous Week', value: 'Previous Week' },
        { name: 'This Month', value: 'This Month' },
        { name: 'Previous Month', value: 'Previous Month' }
      ],
      isShowDate: false,
      showDateStart: "",
      showDateEnd: "",
      menu: false,
      dateStart: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      dateEnd: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      isSearch: false,
      overlayDialogLoading: false,
      dialogLoading: false,
      dialogSearchContext: false,
      searchContextTopic: "",
      searchContextStartDate: "",
      searchContextEndDate: "",
      alert: false,
      colorAlert: "",
      message: "",
      dialogConfirmReset: false,
    }
  },
  computed: {
    ...mapGetters(['navbarWithName']),
    rowListPortalDomain() {
      const chunkSize = 5;
      const result = [];
      for (let i = 0; i < this.listPortalDomain.length; i += chunkSize) {
        result.push(this.listPortalDomain.slice(i, i + chunkSize));
      }
      return result;
    },
    themeItemColor() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700' ? 'var(--color-theme)' : undefined;
    },
    isColorThemeSetneg() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700';
    }
  },
  async created() {
    await this.loadAssetsTheme();
  },
  mounted() {
    this.loadTopic();
  },
  methods: {
    async loadAssetsTheme() {
      try {
        const appTitle = window.APP_CONFIG?.VUE_APP_TITLE || process.env.VUE_APP_TITLE;
        const assetsModule = appTitle == "Websitemedan"
          ? await import('@/constants/asset-logo-MedAn.js')
          : await import('@/constants/asset-logo-Garuda.js');

        this.base64HeaderSolusi247 = assetsModule.BASE64_HEADER_SOLUSI247;
      } catch (error) {
        console.error('Failed to load environment assets:', error);
      }
    },
    async captureAll() {
      trackEvent('media-share-capture-all', {
        topic: this.searchContextTopic,
        keyword: this.selectedKeyword,
        period: this.selectedPeriode
      });

      try {
        this.isCapture = true;
        this.overlayDialogLoading = true;
        this.dialogLoading = true;

        const clusterAnalysisCard = this.$refs.clusterAnalysisCard;
        const entityBubbleCard = this.$refs.entityBubbleCard;

        const [_, canvasCluster, canvasEntityBubblePerson] = await Promise.all([
          this.insightsAICaptureAll(),
          html2canvas(clusterAnalysisCard, { backgroundColor: '#ffffff', scale: 2 }),
          html2canvas(entityBubbleCard, { backgroundColor: '#ffffff', scale: 2, useCORS: true, allowTaint: true })
        ]);

        await this.changeEntity('Organization');
        await this.$nextTick();

        const canvasEntityBubbleOrganization = await html2canvas(entityBubbleCard, {
          backgroundColor: '#ffffff',
          scale: 2,
          useCORS: true,
          allowTaint: true
        });

        await this.changeEntity('Location');
        await this.$nextTick();

        const canvasEntityBubbleLocation = await html2canvas(entityBubbleCard, {
          backgroundColor: '#ffffff',
          scale: 2,
          useCORS: true,
          allowTaint: true
        });

        const imgDataCluster = canvasCluster.toDataURL('image/png');
        const imgDataEntityBubblePerson = canvasEntityBubblePerson.toDataURL('image/png');
        const imgDataEntityBubbleOrganization = canvasEntityBubbleOrganization.toDataURL('image/png');
        const imgDataEntityBubbleLocation = canvasEntityBubbleLocation.toDataURL('image/png');

        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        this.createStandardPageHeader(pdf, pageWidth);

        const footerY = pageHeight - 8;
        pdf.setFontSize(11);
        pdf.setFont(undefined, "normal");
        pdf.setTextColor("#808080");
        pdf.text("HALAMAN 3", 15, footerY);

        const marginX = 15;
        const titleYRow1 = 31;
        const contentFontSize = '17px';
        const columnWidth = pageWidth - (2 * marginX);

        pdf.setFontSize(18);
        pdf.setTextColor('#165476');
        pdf.setFont(undefined, 'bold');
        pdf.text('Analisis Cluster Data Media Online', marginX, titleYRow1, { align: 'left' });

        let insightText = '';
        if (this.clusterAnalysisInsights && this.clusterAnalysisInsights.length > 0) {
          this.clusterAnalysisInsights.forEach(section => {
            insightText += this.formatTextReportMediaShare(section) + '\n\n';
          });
          insightText = insightText.trim();
        }

        let styledHTML = insightText
          .replace(/^# (.*$)/gim, '<h1 style="font-size:16px; font-weight:bold; margin:3px 0;">$1</h1>')
          .replace(/^## (.*$)/gim, '<h2 style="font-size:15px; font-weight:bold; margin:3px 0;">$1</h2>')
          .replace(/^### (.*$)/gim, '<h3 style="font-size:14px; font-weight:600; margin:2px 0;">$1</h3>')
          .replace(/\*\*(.*?)\*\*/gim, '<b>$1</b>')
          .replace(/\*(.*?)\*/gim, '<i>$1</i>')
          .replace(/\n/g, '<br>');

        const textYStart = titleYRow1 + 5;
        const textHeight = 50;

        await pdf.html(
          `<div style="font-family: Helvetica; font-size:${contentFontSize}; line-height:1.5; color:#000;">${styledHTML}</div>`,
          {
            x: marginX,
            y: textYStart,
            width: columnWidth,
            height: textHeight,
            windowWidth: 800,
            autoPaging: 'none',
          }
        );

        const imgYStart = textYStart + textHeight - 2.5;
        const imgWidth = columnWidth;
        const imgHeight = (canvasCluster.height * imgWidth) / canvasCluster.width;

        pdf.addImage(imgDataCluster, 'PNG', marginX, imgYStart, imgWidth, imgHeight);

        const titleYRow2 = imgYStart + imgHeight + 12;

        pdf.setFontSize(18);
        pdf.setTextColor('#165476');
        pdf.setFont(undefined, 'bold');
        pdf.text('Analisis Entitas Berita Online', marginX, titleYRow2, { align: 'left' });

        let entityInsightsText = '';
        if (this.entityInsights && this.entityInsights.length > 0) {
          this.entityInsights.forEach(section => {
            entityInsightsText += this.formatTextReportMediaShare(section) + '\n\n';
          });
          entityInsightsText = entityInsightsText.trim();
        }

        let styledHTMLRow2 = entityInsightsText
          .replace(/^# (.*$)/gim, '<h1 style="font-size:16px; font-weight:bold; margin:3px 0;">$1</h1>')
          .replace(/^## (.*$)/gim, '<h2 style="font-size:15px; font-weight:bold; margin:3px 0;">$1</h2>')
          .replace(/^### (.*$)/gim, '<h3 style="font-size:14px; font-weight:600; margin:2px 0;">$1</h3>')
          .replace(/\*\*(.*?)\*\*/gim, '<b>$1</b>')
          .replace(/\*(.*?)\*/gim, '<i>$1</i>')
          .replace(/\n/g, '<br>');

        const textYStartRow2 = titleYRow2 + 5;
        const textHeightRow2 = 50;

        await pdf.html(
          `<div style="font-family: Helvetica; font-size:${contentFontSize}; line-height:1.5; color:#000;">${styledHTMLRow2}</div>`,
          {
            x: marginX,
            y: textYStartRow2,
            width: columnWidth,
            height: textHeightRow2,
            windowWidth: 800,
            autoPaging: 'none',
          }
        );

        const imgYStartBubbles = textYStartRow2 + textHeightRow2 - 3.5;
        const spacing = 3;
        const imgWidthBubbles = (columnWidth - (spacing * 2)) / 3;

        const imgHeightPerson = (canvasEntityBubblePerson.height * imgWidthBubbles) / canvasEntityBubblePerson.width;
        const imgHeightOrganization = (canvasEntityBubbleOrganization.height * imgWidthBubbles) / canvasEntityBubbleOrganization.width;
        const imgHeightLocation = (canvasEntityBubbleLocation.height * imgWidthBubbles) / canvasEntityBubbleLocation.width;

        pdf.addImage(imgDataEntityBubblePerson, 'PNG', marginX, imgYStartBubbles, imgWidthBubbles, imgHeightPerson);
        pdf.addImage(imgDataEntityBubbleOrganization, 'PNG', marginX + imgWidthBubbles + spacing, imgYStartBubbles, imgWidthBubbles, imgHeightOrganization);
        pdf.addImage(imgDataEntityBubbleLocation, 'PNG', marginX + (imgWidthBubbles * 2) + (spacing * 2), imgYStartBubbles, imgWidthBubbles, imgHeightLocation);

        const pdfBytes = pdf.output("arraybuffer");

        const formattedDate = new Date().toLocaleString("en-US", {
          month: "short",
          day: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });

        const now = new Date();
        const monthShort = now.toLocaleString("en-US", { month: "short" });
        const year = now.getFullYear();

        const getWeekOfMonth = (d = new Date()) => {
          const date = new Date(d.getFullYear(), d.getMonth(), d.getDate());
          const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
          const dayOfMonth = date.getDate();
          const firstDayWeekday = firstDayOfMonth.getDay();

          return Math.ceil((dayOfMonth + firstDayWeekday) / 7);
        };

        let title = "";
        const topicName = this.searchContextTopic;

        switch (this.selectedPeriode) {
          case "Today":
            title = `${topicName} Today Insights Media Share`;
            break;
          case "Tomorrow":
            title = `${topicName} Tomorrow Insights Media Share`;
            break;
          case "This Week":
            title = `${topicName} Week ${getWeekOfMonth()} ${monthShort} Insights Media Share`;
            break;
          case "Previous Week": {
            const prevWeekDate = new Date(now);
            prevWeekDate.setDate(now.getDate() - 7);
            const prevWeekMonth = prevWeekDate.toLocaleString("en-US", { month: "short" });
            const weekNum = getWeekOfMonth(prevWeekDate);
            title = `${topicName} Week ${weekNum} ${prevWeekMonth} Insights Media Share`;
            break;
          }
          case "This Month":
            title = `${topicName} ${monthShort} ${year} Insights Media Share`;
            break;
          case "Previous Month": {
            const prev = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            const prevMonthShort = prev.toLocaleString("en-US", { month: "short" });
            const prevYear = prev.getFullYear();
            title = `${topicName} ${prevMonthShort} ${prevYear} Insights Media Share`;
            break;
          }
          default:
            title = `${topicName} Insights Media Share`;
        }

        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const formData = new FormData();
        formData.append('file', new Blob([pdfBytes], { type: 'application/pdf' }), `${title}.pdf`);
        formData.append("title", title);
        formData.append("nameFile", `${title}.pdf`);
        formData.append("type", "newsletter media share");
        formData.append("date", formattedDate);
        formData.append("topic", this.selectedTopic);
        formData.append("periode", this.selectedPeriode);

        const responseNewsletterMediaShare = await axios.post(
          "insights/upload",
          formData,
          {
            headers: {
              "auth-token": authToken,
            },
          }
        );

        if (responseNewsletterMediaShare.status == 200) {
          this.dialogSuccessGenerateNewsletter = true;
        }

        this.isCapture = false;
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      } catch (error) {
        console.error('Gagal melakukan capture atau menyimpan:', error);
        this.isCapture = false;
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      }
    },
    createStandardPageHeader(doc, pageWidth) {
      const now = new Date();
      const monthName = now.toLocaleString('en-US', { month: 'long' }).toUpperCase();
      const year = now.getFullYear();
      const headerDateText = `${monthName} ${year}`;

      const headerText = `${headerDateText} | SOLUSI247 NEWSLETTER`;

      const logoBase64 = this.base64HeaderSolusi247;
      const logoWidth = 50;
      const logoHeight = 15;
      const marginX = 15;
      const headerY = 15;
      const lineY = headerY + 5;

      doc.setFontSize(11);
      doc.setFont(undefined, "normal");
      doc.setTextColor("#555555");
      doc.text(headerText, marginX, headerY);

      const logoX = pageWidth - logoWidth - marginX;
      const logoY = headerY - 10;

      if (typeof logoBase64 !== "undefined" && logoBase64.length > 0) {
        doc.addImage(logoBase64, "PNG", logoX, logoY, logoWidth, logoHeight);
      }

      doc.setDrawColor(180, 180, 180);
      doc.setLineWidth(0.5);
      doc.line(marginX, lineY, pageWidth - marginX, lineY);
    },
    async insightsAICaptureAll() {
      try {
        const token = localStorage.getItem('token_app');

        try {
          const decodeResponse = await axios.post("decode-token", { token });

          if (!decodeResponse.data.valid) {
            throw { response: { status: 403 } };
          }
        } catch (e) {
          const { status } = e.response || {};

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
          return;
        }

        const axiosInstance = axios.create({
          baseURL: "/apigenerativeAI",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');

        const keywords = this.topicKeywordSentiment
          .filter(item => item.value != "All")
          .map(item => item.value);

        const payload = {
          topic: this.searchContextTopic,
          period: periode,
          keyword: keywords,
          top_n_keyword: 10,
          max_count_source: 3,
        };

        const response = await axiosInstance.post(
          "/gen-ai-medan/api/v2/chat/generate-media-report",
          payload
        );

        const data = response.data?.data || {};

        let clusterAnalysisRaw = data.analisis_cluster_data_media_online || '';
        let entityAnalysisRaw = data.analisis_entitas_berita_online || '';

        const cleanClusterText = (text) =>
          text
            .replace(/^Analisis Cluster Data Media Online\s*/i, '')
            .trim();

        const cleanEntityText = (text) =>
          text
            .replace(/^Berita Online\s*/i, '')
            .trim();

        const clusterAnalysis = cleanClusterText(clusterAnalysisRaw);
        const entityAnalysis = cleanEntityText(entityAnalysisRaw);

        this.clusterAnalysisInsights = clusterAnalysis ? [clusterAnalysis] : [];
        this.entityInsights = entityAnalysis ? [entityAnalysis] : [];
      } catch (error) {
        console.error("Error in postDescribeMediaShare:", error);
      }
    },
    formatTextReportMediaShare(text) {
      if (!text) return "";

      const lines = text.split('\n');
      let htmlOutput = '';

      lines.forEach(line => {
        let trimmed = line.trim();
        if (!trimmed) return;

        if (trimmed.startsWith('- **') && trimmed.includes('**:')) {
          const match = trimmed.match(/^- \*\*(.+?)\*\*:\s*(.*)$/);
          if (match) {
            const boldText = match[1];
            const content = match[2];
            htmlOutput += `<p style="margin-bottom: 2px;">- ${boldText}:</p>`;
            if (content) {
              htmlOutput += `<p style="margin-bottom: 2px;">${content}</p>`;
            }
            return;
          }
        }

        if (/^\d+\.\s+\*\*/.test(trimmed) && trimmed.includes('**:')) {
          const match = trimmed.match(/^(\d+\.)\s+\*\*(.+?)\*\*:\s*(.*)$/);
          if (match) {
            const number = match[1];
            const boldText = match[2];
            const content = match[3];
            htmlOutput += `<p style="margin-bottom: 2px;">${number} ${boldText}:</p>`;
            if (content) {
              htmlOutput += `<p style="margin-bottom: 2px;">${content}</p>`;
            }
            return;
          }
        }

        trimmed = trimmed.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

        const headingMatch = trimmed.match(/^(#{1,6})\s+(.*)$/);
        if (headingMatch) {
          const level = headingMatch[1].length;
          const content = headingMatch[2];
          htmlOutput += `<h${level}>${content}</h${level}>`;
        } else if (/^\d+\./.test(trimmed)) {
          htmlOutput += `<p style="margin-bottom: 2px;">${trimmed}</p>`;
        } else if (trimmed.startsWith('- ')) {
          htmlOutput += `<p style="margin-bottom: 2px;">${trimmed}</p>`;
        } else {
          htmlOutput += `<p style="margin-bottom: 0px;">${trimmed}</p>`;
        }
      });

      return htmlOutput;
    },
    regenerateInsight() {
      this.isRotatingRegenerateInsight = true;

      setTimeout(() => {
        this.isRotatingRegenerateInsight = false;
      }, 500);

      this.indexOpenInsight = this.listIndexOpenInsight.length - 1;
      this.listIndexOpenInsight[this.indexOpenInsight] = true;
      this.postDescribeDashboardData();
      this.dialogPageInsight = true;
    },
    async insightAIassistant() {
      trackEvent('media-share-insight-ai');
      this.postDescribeDashboardData();
    },
    async postDescribeDashboardData() {
      this.dialogPageInsight = !this.dialogPageInsight;
      if (this.listIndexOpenInsight[this.listIndexOpenInsight.length - 1] != false) {
        this.listResponseDescribeDashboard = [];
        this.currentLoadingIndex = 0;
        this.listIndexOpenInsight[this.indexOpenInsight] = false;
        this.indexOpenInsight += 1;

        this.loadingResponseDescribeDashboard = true;

        try {
          const token = localStorage.getItem('token_app');

          try {
            const decodeResponse = await axios.post("decode-token", { token });

            if (!decodeResponse.data.valid) {
              throw { response: { status: 403 } };
            }

          } catch (e) {
            this.loadingResponseDescribeDashboard = false;
            const { status } = e.response || {};

            switch (status) {
              case 404:
                this.$refs.alert.error_login(404);
                break;
              case 403:
                this.$refs.alert.error_login(403);
                break;
              default:
                console.log("some other error");
                break;
            }
            return;
          }

          await this.getMediaBubbleEntityInsightAI();
          await this.loadContentInsightAI();

          const axiosInstance = axios.create({
            baseURL: "/apigenerativeAI",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');

          const mediaLineChartData = this.seriesSentiment.map(media => {
            return {
              date: media.data.map(item => item.x),
              values: media.data.map(item => item.y || 0),
              media: media.name
            };
          });

          const dateMap = {};
          mediaLineChartData.forEach(media => {
            media.date.forEach((date, index) => {
              if (!dateMap[date]) {
                dateMap[date] = {
                  date: date,
                  media_value: []
                };
              }
              dateMap[date].media_value.push({
                value: media.values[index],
                media: media.media
              });
            });
          });
          const formattedMediaLineChart = Object.values(dateMap);

          const mediaSummary = this.seriesSentiment.map(media => {
            const total = media.data.reduce((sum, item) => sum + (item.y || 0), 0);
            return {
              media: media.name,
              value: total
            };
          });

          const entityTypes = ["Person", "Organization", "Location"];

          const entityBubbleData = entityTypes.map(type => ({
            bubbles_tab: type,
            bubbles: this.entitiesAll
              .filter(entity => entity.type == type)
              .map(entity => ({
                name: entity.name,
                value: entity.contents
              }))
          }));

          const contentListData = [
            {
              sentiment: "Positive",
              percentage: this.beritaPositivePersen || 0,
              total_data: this.beritaPositive || 0,
              contents: this.kontenBeritaAll
                .flat()
                .filter(item => item.sentiment__s == "Positive")
                .slice(0, 3)
                .map(item => ({
                  title: item.title,
                  content: item.content,
                  url: item.url,
                  media: item.domain
                }))
            },
            {
              sentiment: "Negative",
              percentage: this.beritaNegativePersen || 0,
              total_data: this.beritaNegative || 0,
              contents: this.kontenBeritaAll
                .flat()
                .filter(item => item.sentiment__s == "Negative")
                .slice(0, 3)
                .map(item => ({
                  title: item.title,
                  content: item.content,
                  url: item.url,
                  media: item.domain
                }))
            },
            {
              sentiment: "Neutral",
              percentage: this.beritaNetralPersen || 0,
              total_data: this.beritaNetral || 0,
              contents: this.kontenBeritaAll
                .flat()
                .filter(item => item.sentiment__s == "Neutral")
                .slice(0, 3)
                .map(item => ({
                  title: item.title,
                  content: item.content,
                  url: item.url,
                  media: item.domain
                }))
            }
          ];

          const payload = {
            topic: this.searchContextTopic,
            period: periode,
            keyword: this.topicKeywordSentiment
              .filter(item => item.value != "All")
              .map(item => item.value),
            data: [
              {
                component_name: "Periodic Media Content",
                data: [
                  {
                    item_name: "Media Line Chart",
                    item_data: formattedMediaLineChart
                  },
                  {
                    item_name: "Media Summary",
                    item_data: mediaSummary
                  }
                ]
              },
              {
                component_name: "Entity Bubble",
                data: entityBubbleData
              },
              {
                component_name: "Content List",
                data: contentListData
              }
            ]
          };

          const response = await axiosInstance.post(
            "/gen-ai-medan/api/v1/chat/describe-media-share",
            payload
          );

          const dashboardText = response.data.data.response;
          const lines = dashboardText.replace(/\r/g, '').split('\n');
          this.listResponseDescribeDashboard = [];

          let currentSection = "";
          let isInRincianKonten = false;

          lines.forEach((line, index) => {
            const trimmed = line.trim();
            if (!trimmed) return;

            const headingMatch = trimmed.match(/^(#{1,6})\s+(.*)$/);
            if (headingMatch) {
              const level = headingMatch[1].length;
              const headingText = headingMatch[2];

              if (level == 2 && headingText.includes("Rincian Konten")) {
                if (currentSection) {
                  this.listResponseDescribeDashboard.push(currentSection.trim());
                }
                currentSection = trimmed;
                isInRincianKonten = true;
              } else if (
                isInRincianKonten &&
                level == 3 &&
                (
                  headingText.includes("Konten Positif") ||
                  headingText.includes("Konten Negatif") ||
                  headingText.includes("Konten Netral")
                )
              ) {
                currentSection += '\n' + trimmed;
              } else if (level <= 2) {
                if (currentSection) {
                  this.listResponseDescribeDashboard.push(currentSection.trim());
                  currentSection = "";
                }
                currentSection = trimmed;
                isInRincianKonten = false;
              } else {
                currentSection += '\n' + trimmed;
              }
            } else {
              currentSection += '\n' + trimmed;
            }

            if (index == lines.length - 1 && currentSection) {
              this.listResponseDescribeDashboard.push(currentSection.trim());
            }
          });

          const totalItems = this.listResponseDescribeDashboard.length;
          const interval = setInterval(() => {
            this.currentLoadingIndex++;
            if (this.currentLoadingIndex >= totalItems) {
              clearInterval(interval);
              this.loadingResponseDescribeDashboard = false;
            }
          }, 500);
        } catch (error) {
          console.error("Error in postDescribeDashboardData:", error);
          this.loadingResponseDescribeDashboard = false;
          this.listResponseDescribeDashboard = ["The server is busy. Please try again later."];
        }
      }
    },
    formatTextDescribeDashboard(text) {
      if (!text) return "";

      const lines = text.split('\n');
      let htmlOutput = '';

      lines.forEach(line => {
        let trimmed = line.trim();
        if (!trimmed) return;

        if (/^#{1,6}$/.test(trimmed)) return;

        trimmed = trimmed.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
        trimmed = trimmed.replace(/\*(.+?)\*/g, '<em>$1</em>');

        const headingMatch = trimmed.match(/^(#{1,6})\s+(.+)$/);
        if (headingMatch) {
          const level = headingMatch[1].length;
          const content = headingMatch[2];
          htmlOutput += `<h${level} style="margin:10px 0 6px;">${content}</h${level}>`;
          return;
        }

        if (/^\d+\.\s+/.test(trimmed)) {
          htmlOutput += `<p style="margin:4px 0;font-weight:600;">${trimmed}</p>`;
          return;
        }

        if (trimmed.startsWith('- ')) {
          htmlOutput += `<p style="margin:2px 0 2px 14px;">• ${trimmed.slice(2)}</p>`;
          return;
        }

        htmlOutput += `<p style="margin-bottom:6px;">${trimmed}</p>`;
      });

      return htmlOutput;
    },
    async getMediaBubbleEntityInsightAI() {
      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const entityConfigs = [
          { type: "Person", endpoint: "/media-bubble-person", path: "data_person" },
          { type: "Organization", endpoint: "/media-bubble-organization", path: "data_organization" },
          { type: "Location", endpoint: "/media-bubble-location", path: "data_location" }
        ];

        const keywordRequestValue = encodeKeywordRequest("", this.topicKeywordSentiment);

        const requests = entityConfigs.map(config => {
          const url = `${config.endpoint}?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${this.sentimentSearch}&start=0&rows=${this.pageplay}&portal=${this.selectedPortal}`;
          return axios.post(url, {}, {
            headers: { 'auth-token': authToken }
          }).then(res => ({
            type: config.type,
            data: res.data.data[config.path]
          }));
        });

        const results = await Promise.all(requests);

        const allEntities = results.flatMap(({ type, data }) =>
          this.generateEntities(data, type).map(entity => ({
            ...entity,
            type
          }))
        );

        this.entitiesAll = allEntities;
      } catch (e) {
        console.log(e);
      }
    },
    async loadContentInsightAI() {
      this.kontenBeritaAll = [];
      const listSentiment = ["Positive", "Neutral", "Negative"];
      for (let i = 0; i < listSentiment.length; i++) {
        try {
          const authToken = localStorage.getItem("token_app");
          if (!authToken) {
            throw new Error("Auth token not found");
          }

          const keywordRequestValue = encodeKeywordRequest("", this.topicKeywordSentiment);

          const dataContent = await axios.post(
            `media-share-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${listSentiment[i]}&start=0&rows=${this.pageplay}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&ner_location=${this.nerLocationSearch}&portal=${this.selectedPortal}`,
            {},
            {
              headers: {
                'auth-token': authToken,
              },
            }
          );

          const data = decryptionData(dataContent.data.data.data_content);
          this.kontenBeritaAll.push(data);
        } catch(e) {
          console.log(e);
        }
      }
    },
    loadMediaShare() {
      trackEvent('media-share', {
        topic: this.searchContextTopic,
        keyword: this.selectedKeyword,
        period: this.selectedPeriode
      });

      this.alert = false;
      this.colorAlert = "";
      this.message = "";
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      Promise.all([
        this.loadPortalMediaShare(),
        this.getMediaBubbleEntity(),
      ]).finally(() => {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      });

      for (let i = 0; i < this.topicSentiment.length; i++) {
        if (this.topicSentiment[i].SEQ_ID == this.$store.topic_glob) {
          this.searchContextTopic = this.topicSentiment[i].TOPIC;
        }
      }

      this.listIndexOpenInsight.push(true);
    },
    showTooltip(entity, event) {
      this.tooltip.visible = true;
      this.tooltip.data = entity;
      this.moveTooltip(event);
    },
    moveTooltip(event) {
      this.tooltip.top = event.clientY - 100;
      this.tooltip.left = event.clientX + 20;
    },
    hideTooltip() {
      this.tooltip.visible = false;
    },
    openDialogSearchContext() {
      this.dialogSearchContext = true;
      setTimeout(() => {
        this.dialogSearchContext = false;
      }, 10000);
    },
    showPeriodeDate() {
      this.isShowDate = true;

      var date = new Date(this.dateStart);
      var day2 = (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "/" +
        date.getFullYear();

      const parts = day2.split("/");
      parts.unshift(parts.pop());
      parts[1] -= 1;
      var dateString = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts)).replace(/,/g, "");

      dateString = dateString.split(" ");
      this.showDateStart = dateString;

      var date3 = new Date(this.dateEnd);
      var day4 = (date3.getMonth() > 8 ? date3.getMonth() + 1 : "0" + (date3.getMonth() + 1)) + "/" +
        (date3.getDate() > 9 ? date3.getDate() : "0" + date3.getDate()) + "/" +
        date3.getFullYear();

      const parts2 = day4.split("/");
      parts2.unshift(parts2.pop());
      parts2[1] -= 1;
      var dateString2 = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts2)).replace(/,/g, "");

      dateString2 = dateString2.split(" ");
      this.showDateEnd = dateString2;

      let jenisParameter = "";
      if (this.selectedPeriode == "Custom") {
        jenisParameter = "custom";
      } else {
        jenisParameter = "periode";
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: jenisParameter,
        topic_glob: this.selectedTopic,
        topic_glob2: this.selectedKeyword,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: this.dateStart,
        date_end_glob: this.dateEnd,
        is_show_date_glob: this.isShowDate
      });
    },
    async loadTopic() {
      this.isSearch = true;
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      try {
        const [keywordSelectResponse, topicKeywordResponse] = await Promise.all([
          axios.get("keyword_select", {
            headers: { 'auth-token': localStorage.getItem('token_app') },
            dataType: 'json'
          }),
          axios.get("topic-keyword", {
            headers: { 'auth-token': localStorage.getItem('token_app') },
            dataType: 'json'
          })
        ]);

        const dataDecryption = decryptionData(keywordSelectResponse.data.token);
        const data = dataDecryption.keyword;
        const collections = dataDecryption.collection;

        const topicKeywordData = decryptionData(topicKeywordResponse.data.token);
        const topicKeywordList = topicKeywordData.data.filter(item => item.GROUP_STATUS == 1);

        const completedTopicData = processTopicKeywords(data, collections, topicKeywordList);

        if (!data || data.length == 0) {
          this.listSourceCollection = collections;
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
          this.isSearch = false;
          return;
        }

        for (let i = 0; i < completedTopicData.length; i++) {
          if (i == 0) {
            if (this.$store.topic_glob == "" || this.$store.topic_glob === undefined) {
              this.selectedTopic = completedTopicData[i].SEQ_ID;
            } else {
              this.selectedTopic = this.$store.topic_glob;
            }
          }
          this.topicSentiment.push(completedTopicData[i]);
        }

        if (typeof this.selectedTopic === "string") {
          for (let i = 0; i < this.topicSentiment.length; i++) {
            if (this.selectedTopic == this.topicSentiment[i].TOPIC) {
              this.selectedTopic = this.topicSentiment[i].SEQ_ID;
              this.$store.topic_glob = this.selectedTopic;
            }
          }
        }

        this.$store.commit("addTopicKeyword", {
          topickeywordsentiment_glob: completedTopicData,
        });

        this.topicKeywordSentiment = [];
        let all = "All";

        for (let i = 0; i < completedTopicData.length; i++) {
          if (completedTopicData[i].SEQ_ID == this.selectedTopic) {
            this.topicKeywordSentiment.push(all);

            for (let x = 0; x < completedTopicData[i].KEYWORD.length; x++) {
              if (x == 0) {
                if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 === undefined) {
                  this.selectedKeyword = all;
                } else {
                  this.selectedKeyword = this.$store.topic_glob2;
                }
              }
              this.topicKeywordSentiment.push(completedTopicData[i].KEYWORD[x].KEYWORD);
            }
            this.searchContextTopic = data[i].TOPIC;
          }
        }

        this.topicKeywordSentiment = this.topicKeywordSentiment.map((keyword, index) => ({
          text: keyword,
          value: keyword,
          disabled: index != 0,
        }));

        this.isShowDate = this.$store.is_show_date_glob;
        var date_start = this.dateStart;
        var date_end = this.dateEnd;

        if (this.$store.jenis_parameter_glob == "custom") {
          date_start = this.$store.date_start_glob;
          date_end = this.$store.date_end_glob;
        } else {
          let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
          let date_v = generateFilterDate(periode);
          date_start = date_v.start_date;
          date_end = date_v.end_date;
        }

        if (this.$store.date_start_glob == "" || this.$store.date_start_glob === undefined) {
          this.$store.commit("addParameter", {
            jenis_parameter_glob: "periode",
            topic_glob: this.selectedTopic,
            topic_glob2: this.selectedKeyword,
            selectedPeriode_glob: this.selectedPeriode,
            date_start_glob: date_start,
            date_end_glob: date_end,
            is_show_date_glob: this.isShowDate
          });
        } else {
          this.selectedKeyword = this.$store.topic_glob2;
          this.selectedPeriode = this.$store.selectedPeriode_glob;
          this.dateStart = this.$store.date_start_glob;
          this.dateEnd = this.$store.date_end_glob;
        }

        if (data.length > 0) {
          this.loadMediaShare();
        } else {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
          this.isSearch = false;
        }

        if (this.isShowDate == true) {
          this.showPeriodeDate();
        }

        let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
        let date_v = generateFilterDate(periode);
        date_start = date_v.start_date;
        date_end = date_v.end_date;
        this.dateStart = date_start;
        this.dateEnd = date_end;

        this.searchContextStartDate = this.dateStart;
        this.searchContextEndDate = this.dateEnd;
      } catch (e) {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        this.isSearch = false;
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Keyword Select Refused To Connect";
          this.colorAlert = "red";
        }
      }
    },
    async parameterProsesTopic() {
      var date_start = this.dateStart;
      var date_end = this.dateEnd;

      this.topicKeywordSentiment = [];
      let all = "All";
      for (let i = 0; i < this.$store.topickeywordsentiment_glob.length; i++) {
        if (this.$store.topickeywordsentiment_glob[i].SEQ_ID == this.selectedTopic) {
          this.topicKeywordSentiment.push(all);
          for (let x = 0; x < this.$store.topickeywordsentiment_glob[i].KEYWORD.length; x++) {
            if (x == 0) {
              if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 === undefined) {
                this.selectedKeyword = all;
              } else {
                this.selectedKeyword = this.$store.topic_glob2;
              }
            }
            this.topicKeywordSentiment.push(this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
          }
        }
      }

      this.topicKeywordSentiment = this.topicKeywordSentiment.map((keyword, index) => ({
        text: keyword,
        value: keyword,
        disabled: index != 0,
      }));

      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
      if (this.selectedKeyword != "All") {
        this.selectedKeyword = "All";
      }
    },
    async parameterProsesKeyword() {
      var date_start = this.dateStart;
      var date_end = this.dateEnd;
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
      this.parameterProsesPeriode();
    },
    async parameterProsesPeriode() {
      let date_start = this.dateStart;
      let date_end = this.dateEnd;
      if (this.selectedPeriode != 'Custom') {
        let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
        let date_v = generateFilterDate(periode);
        date_start = date_v.start_date;
        date_end = date_v.end_date;
        this.dateStart = date_start;
        this.dateEnd = date_end;
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "periode",
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });

      this.searchContextStartDate = date_start;
      this.searchContextEndDate = date_end;
      this.showPeriodeDate();
    },
    async parameterProsesCustom() {
      this.selectedPeriode = "Custom";

      var date_start = this.dateStart;
      var date_end = this.dateEnd;

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "custom",
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
    },
    filterReset() {
      trackEvent('media-share-reset');
      this.$store.commit("addButtonTmp", {
        sentiment_glob: "",
        ner_person_glob: "",
        ner_organization_glob: "",
      });
    },
    async changeEntity(entityType) {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;
      this.selectedEntity = entityType;
      this.nerPersonSearch = "";
      this.nerOrganizationSearch = "";
      this.nerLocationSearch = "";

      try {
        await this.getMediaBubbleEntity();
      } finally {
        if (this.isCapture == false) {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
        }
      }
    },
    async loadPortalMediaShare() {
      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const keywordRequestValue = encodeKeywordRequest("", this.topicKeywordSentiment);

        const [chartResponse, iconResponse] = await Promise.all([
          axios.post(
            `media-chart?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${this.sentimentSearch}&start=0&rows=${this.pageplay}&portal=${this.selectedPortal}`,
            {},
            { headers: { 'auth-token': authToken } }
          ),
          axios.get(
            `news-icon`,
            { headers: { 'auth-token': authToken } }
          )
        ]);

        this.processDataPortal(chartResponse.data.data, iconResponse.data.token);
      } catch(e) {
        console.log(e);
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Media Chart Response Data Not Found";
        this.colorAlert = "red";
      }
    },
    processDataPortal(data, iconData) {
      this.chartSentimentPortal = data;
      const platformKey = "date_mediaonline";
      const domainData = data[platformKey] || [];

      const combinedData = {};
      const totalPerDomain = {};

      const domainImageMap = {};
      iconData.forEach(icon => {
        domainImageMap[icon.DOMAIN] = icon.PRS_IMAGE;
      });

      domainData.forEach((item) => {
        const dateKey = item.date;
        const domain = item.domain;

        if (!combinedData[dateKey]) {
          combinedData[dateKey] = {};
        }

        if (!combinedData[dateKey][domain]) {
          combinedData[dateKey][domain] = 0;
        }

        combinedData[dateKey][domain] += item.Total;

        if (!totalPerDomain[domain]) {
          totalPerDomain[domain] = 0;
        }
        totalPerDomain[domain] += item.Total;
      });

      const sortedDomains = Object.entries(totalPerDomain)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 10);

      const top10Domains = sortedDomains.map(([domain]) => domain);

      const sortedDates = Object.keys(combinedData).sort();
      const categories = sortedDates.map(date => new Date(date).getTime());
      this.sentimentAnalysis.xaxis.categories = categories;
      this.seriesSentiment = [];

      const predefinedColors = [
        "#6F6F6F", "#FFB000", "#B87333", "#000", "#814AD6",
        "#bd0ca0", "#4b5320", "#3bacad", "#b2e069", "#b9a389"
      ];

      top10Domains.forEach((domain, i) => {
        const cleanDomain = domain
          .replace(/\.com$/, '')
          .replace(/\.co\.id$/, '')
          .replace(/\.id$/, '')
          .replace(/\.net$/, '')
          .replace(/\.org$/, '')
          .replace(/\.co$/, '')
          .replace(/\.web\.id$/, '')
          .replace(/\.ac\.id$/, '')
          .replace(/\.go\.id$/, '')
          .replace(/\.sch\.id$/, '')
          .replace(/\.or\.id$/, '');

        this.seriesSentiment.push({
          name: cleanDomain,
          data: [],
          color: predefinedColors[i]
        });
      });

      sortedDates.forEach(dateKey => {
        const formattedDate = this.formatDate(dateKey);
        top10Domains.forEach((domain, index) => {
          const count = combinedData[dateKey][domain] || 0;
          this.seriesSentiment[index].data.push({
            x: formattedDate,
            y: count,
          });
        });
      });

      this.urlLogoPortalDomain = axios.defaults.baseURL;

      this.listPortalDomain = sortedDomains.map(([domain, total], i) => ({
        id: i,
        name: domain,
        total: total,
        icon: 'fa-thin fa-globe',
        color: predefinedColors[i],
        PRS_IMAGE: domainImageMap[domain] || null
      }));

      const listPrsImage = iconData.map(item => ({
        PRS_IMAGE: item.PRS_IMAGE,
        DOMAIN: item.DOMAIN
      }));
      this.listPrsImageDomain = listPrsImage;

      const countAll = data.count_negative + data.count_neutral + data.count_positive;
      this.totalCollectedData = countAll;
      const beritaNegativePersen = data.count_negative / countAll * 100;
      this.beritaNegativePersen = parseFloat(beritaNegativePersen.toFixed(2));
      this.beritaNegative = data.count_negative;

      const beritaNetralPersen = data.count_neutral / countAll * 100;
      this.beritaNetralPersen = parseFloat(beritaNetralPersen.toFixed(2));
      this.beritaNetral = data.count_neutral;

      const beritaPositivePersen = data.count_positive / countAll * 100;
      this.beritaPositivePersen = parseFloat(beritaPositivePersen.toFixed(2));
      this.beritaPositive = data.count_positive;

      this.pageLengthPositive = Math.ceil(data.count_positive / this.pageplay);
      this.pageLengthNetral = Math.ceil(data.count_neutral / this.pageplay);
      this.pageLengthNegative = Math.ceil(data.count_negative / this.pageplay);

      if (isNaN(beritaPositivePersen)) {
        this.beritaPositivePersen = 0;
      }
      if (isNaN(beritaNetralPersen)) {
        this.beritaNetralPersen = 0;
      }
      if (isNaN(beritaNegativePersen)) {
        this.beritaNegativePersen = 0;
      }

      let maxSentiment = Math.max(this.beritaPositive, this.beritaNetral, this.beritaNegative);

      if (maxSentiment == this.beritaPositive) {
        this.selectedTab = 0;
        this.tabsSentiment = "Positive";
      } else if (maxSentiment == this.beritaNetral) {
        this.selectedTab = 1;
        this.tabsSentiment = "Neutral";
      } else {
        this.selectedTab = 2;
        this.tabsSentiment = "Negative";
      }
      this.loadCluster();
      this.loadContent();
    },
    formatDate(date) {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    },
    async getMediaBubbleEntity() {
      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        let apiEndpoint = '';
        let responseDataPath = '';

        switch(this.selectedEntity) {
          case 'Person':
            apiEndpoint = '/media-bubble-person';
            responseDataPath = 'data_person';
            break;
          case 'Organization':
            apiEndpoint = '/media-bubble-organization';
            responseDataPath = 'data_organization';
            break;
          case 'Location':
            apiEndpoint = '/media-bubble-location';
            responseDataPath = 'data_location';
            break;
          default:
            throw new Error('Invalid entity type');
        }

        const keywordRequestValue = encodeKeywordRequest("", this.topicKeywordSentiment);

        const entityResponse = await axios.post(
          `${apiEndpoint}?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${this.sentimentSearch}&start=0&rows=${this.pageplay}&portal=${this.selectedPortal}`,
          {},
          { headers: { 'auth-token': authToken } }
        );

        const responseData = entityResponse.data.data[responseDataPath];
        this.entities = this.generateEntities(responseData, this.selectedEntity);
      } catch(e) {
        console.log(e);
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Media Bubble Response Data Not Found";
        this.colorAlert = "red";
      }
    },
    generateEntities(response, entityType) {
      const fieldName = entityType == 'Person' ? 'person' :
                        entityType == 'Organization' ? 'organization' :
                        'location';

      const entityData = {};

      response.forEach(item => {
      if (item[fieldName] && item[fieldName].toLowerCase() != 'not detected') {
        let name = item[fieldName].trim();
        if (entityType == 'Location') {
          name = name.replace(/^\[|\]$/g, '').trim();
          if (!name) return;
        }

        if (!entityData[name]) {
          entityData[name] = {
            count: 0,
            image: item.image,
            nameOriginal: item.nameOriginal,
            domains: new Set(),
            neutral: 0,
            negative: 0,
            positive: 0,
            total: 0
          };
        }

        entityData[name].count += item.total;
        item.domain.forEach(domain => entityData[name].domains.add(domain));
        entityData[name].neutral += item.neutral || 0;
        entityData[name].negative += item.negative || 0;
        entityData[name].positive += (item.total || 0) - (item.neutral || 0) - (item.negative || 0);
        entityData[name].total += item.total || 0;

        if (item.image && !entityData[name].image) {
          entityData[name].image = item.image;
        }
      }
    });
    const topEntities = Object.entries(entityData)
      .sort((a, b) => b[1].count - a[1].count)
      .slice(0, 10)
      .map(([name, data]) => {
        const neutralPctRaw = (data.neutral / data.total) * 100;
        const negativePctRaw = (data.negative / data.total) * 100;
        const positivePctRaw = (data.positive / data.total) * 100;

        let neutralPct = Math.round(neutralPctRaw);
        let negativePct = Math.round(negativePctRaw);
        let positivePct = Math.round(positivePctRaw);

        const totalPct = neutralPct + negativePct + positivePct;
        if (totalPct != 100) {
          const decimals = [
            { type: 'neutral', value: neutralPctRaw % 1 },
            { type: 'negative', value: negativePctRaw % 1 },
            { type: 'positive', value: positivePctRaw % 1 }
          ].sort((a, b) => b.value - a.value);

          if (totalPct > 100) {
            if (decimals[0].type == 'neutral') neutralPct--;
            else if (decimals[0].type == 'negative') negativePct--;
            else positivePct--;
          } else {
            if (decimals[0].type == 'neutral') neutralPct++;
            else if (decimals[0].type == 'negative') negativePct++;
            else positivePct++;
          }
        }

        return {
          name,
          value: data.count,
          image: data.image,
          sources: data.domains.size,
          neutral: neutralPct,
          negative: negativePct,
          positive: positivePct,
          total: data.total,
          totPositive: data.positive,
          totNeutral: data.neutral,
          totNegative: data.negative,
          domains: Array.from(data.domains),
          nameOriginal: data.nameOriginal
        };
      });
      const values = topEntities.map(e => e.value);
      const minValue = Math.min(...values);
      const maxValue = Math.max(...values);

      const minSize = 40;
      const maxSize = 160;

      function scaleSize(value) {
        if (maxValue == minValue) return (minSize + maxSize) / 2;
        return minSize + ((value - minValue) / (maxValue - minValue)) * (maxSize - minSize);
      }

      const sizes = topEntities.map(e => scaleSize(e.value));
      const allSameSize = sizes.every(size => size == sizes[0]);

      const positionTemplate = allSameSize
        ? [
            { top: 10, left: 0 },
            { top: -10, left: 150 },
            { top: 10, left: 300 },
            { top: 120, left: 30 },
            { top: 115, left: 160 },
            { top: 120, left: 290 },
            { top: 225, left: 60 },
            { top: 225, left: 200 },
            { top: 225, left: 320 },
            { top: 320, left: 130 }
          ]
        : [
            { top: 20, left: -20 },
            { top: -10, left: 150 },
            { top: 20, left: 320 },
            { top: 195, left: 30 },
            { top: 170, left: 180 },
            { top: 175, left: 300 },
            { top: 280, left: 160 },
            { top: 280, left: 260 },
            { top: 280, left: 330 },
            { top: 340, left: 220 }
          ];

      const scaledEntities = topEntities.map((entity, index) => ({
        name: entity.name,
        image: entity.image,
        total: entity.value,
        size: sizes[index],
        top: positionTemplate[index]?.top || 0,
        left: positionTemplate[index]?.left || 0,
        contents: entity.value,
        sources: entity.sources,
        positive: entity.positive,
        negative: entity.negative,
        neutral: entity.neutral,
        totPositive: entity.totPositive,
        totNeutral: entity.totNeutral,
        totNegative: entity.totNegative,
        domains: entity.domains,
        nameOriginal: entity.nameOriginal
      }));

      return scaledEntities;
    },
    async loadDataBySelectedPortal(portalName) {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;
      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const iconResponse = await axios.get(
          `news-icon`,
          { headers: { 'auth-token': authToken } }
        );

        if (this.selectedPortal == "") {
          this.processDataPortal(this.chartSentimentPortal, iconResponse.data.token);
          await this.getMediaBubbleEntity();
        } else {
          await this.processDataBySelectedPortal(portalName);
        }

        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      } catch(e) {
        console.log(e);
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Media Chart Response Data Not Found";
        this.colorAlert = "red";
      }
    },
    async processDataBySelectedPortal(portalName) {
      const portalData = this.chartSentimentPortal.date_mediaonline.filter(item => item.domain == portalName);

      trackEvent('media-share-portal', {portal: portalName});

      let portalPositive = 0;
      let portalNeutral = 0;
      let portalNegative = 0;

      portalData.forEach(item => {
        portalPositive += item.Positive || 0;
        portalNeutral += item.Netral || 0;
        portalNegative += item.Negative || 0;
      });

      const sentimentData = {};
      portalData.forEach(item => {
        const dateKey = item.date;
        if (!sentimentData[dateKey]) {
          sentimentData[dateKey] = {
            positive: 0,
            neutral: 0,
            negative: 0
          };
        }
        sentimentData[dateKey].positive += item.Positive || 0;
        sentimentData[dateKey].neutral += item.Netral || 0;
        sentimentData[dateKey].negative += item.Negative || 0;
      });

      const sortedDates = Object.keys(sentimentData).sort();
      const categories = sortedDates.map(date => new Date(date).getTime());
      this.sentimentAnalysis.xaxis.categories = categories;

      this.seriesSentiment = [
        {
          name: "Positive",
          data: sortedDates.map(date => ({
            x: this.formatDate(date),
            y: sentimentData[date].positive
          })),
          color: "#00E396"
        },
        {
          name: "Neutral",
          data: sortedDates.map(date => ({
            x: this.formatDate(date),
            y: sentimentData[date].neutral
          })),
          color: "#008FFB"
        },
        {
          name: "Negative",
          data: sortedDates.map(date => ({
            x: this.formatDate(date),
            y: sentimentData[date].negative
          })),
          color: "#FF4560"
        }
      ];

      const countAll = portalNegative + portalNeutral + portalPositive;

      const beritaNegativePersen = countAll > 0 ? portalNegative / countAll * 100 : 0;
      this.beritaNegativePersen = parseFloat(beritaNegativePersen.toFixed(2));
      this.beritaNegative = portalNegative;

      const beritaNetralPersen = countAll > 0 ? portalNeutral / countAll * 100 : 0;
      this.beritaNetralPersen = parseFloat(beritaNetralPersen.toFixed(2));
      this.beritaNetral = portalNeutral;

      const beritaPositivePersen = countAll > 0 ? portalPositive / countAll * 100 : 0;
      this.beritaPositivePersen = parseFloat(beritaPositivePersen.toFixed(2));
      this.beritaPositive = portalPositive;

      this.pageLengthPositive = Math.ceil(portalPositive / this.pageplay);
      this.pageLengthNetral = Math.ceil(portalNeutral / this.pageplay);
      this.pageLengthNegative = Math.ceil(portalNegative / this.pageplay);

      let maxSentiment = Math.max(this.beritaPositive, this.beritaNetral, this.beritaNegative);

      if (maxSentiment == this.beritaPositive) {
        this.selectedTab = 0;
        this.tabsSentiment = "Positive";
      } else if (maxSentiment == this.beritaNetral) {
        this.selectedTab = 1;
        this.tabsSentiment = "Neutral";
      } else {
        this.selectedTab = 2;
        this.tabsSentiment = "Negative";
      }

      await this.loadCluster();
      await this.getMediaBubbleEntity();
      await this.loadContent();
    },
    async loadCluster() {
      this.loadDataSendTopicLatest();

      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      try {
        const authToken = localStorage.getItem('token_app');
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const getStoreValue = (key, defaultValue = "") => {
          return this.$store[key] || defaultValue;
        };
        const objectFilterLogika = getStoreValue("finalobjectfilterlogika_glob", "");

        let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');

        const keywordRequestValue = encodeKeywordRequest("", this.topicKeywordSentiment);

        const dataFoarm = await axios.post(
          `honeycon-cluster?period=${periode}&start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${keywordRequestValue}&sentiment=${this.sentimentSearch}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&domain=${this.selectedPortal}&logic=${JSON.stringify(objectFilterLogika)}&start=0&rows=${this.pageplay}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const responseData = dataFoarm?.data?.data;

        const clusterData =
          responseData?.cluster ||
          responseData?.[this.selectedPortal]?.cluster ||
          null;

        this.$refs.clustercarot?.carrot(clusterData);

        window.dispatchEvent(new Event("resize"));
      } catch(e) {
        console.log(e);
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Honeycon Cluster Response Data Not Found";
        this.colorAlert = "red";
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      }
    },
    async loadDataSendTopicLatest() {
      try {
        const authToken = localStorage.getItem('token_app');
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        let periode = this.$store.selectedPeriode_glob.toUpperCase().replace(/ /g, '_');
        const topic = this.$store.topic_glob;

        const endpoints = ['SCHEDULER HONECON', 'HONECON'];

        const results = [];

        for (const endpoint of endpoints) {
          const response = await axios.get(
            `data-send-topic-last-calculated?periode=${periode}&topic=${topic}&endpoint=${endpoint}`,
            {
              headers: {
                'auth-token': authToken,
              },
            }
          );

          const result = response?.data?.data?.result;

          if (Array.isArray(result) && result.length > 0 && result[0].CREATED_AT) {
            results.push(result[0]);
          }
        }

        if (results.length > 0) {
          const latest = results.reduce((a, b) => a.SEQ_ID > b.SEQ_ID ? a : b);
          this.lastCalculatedOn = this.formatDateReadable(latest.CREATED_AT);
        } else {
          this.lastCalculatedOn = '-';
        }
      } catch (error) {
        this.lastCalculatedOn = '-';
      }
    },
    formatDateReadable(dateString) {
      const [datePart, timePart] = dateString.split(' ');
      const [day, month, year] = datePart.split('-');

      const monthNames = [
        'Jan', 'Feb', 'Mar', 'Apr',
        'May', 'Jun', 'Jul', 'Aug',
        'Sep', 'Oct', 'Nov', 'Dec'
      ];

      const monthName = monthNames[parseInt(month) - 1];

      return `${day} ${monthName} ${year}, ${timePart}`;
    },
    zoomOut() {
      this.$refs.clustercarot.resetZoom();
    },
    async loadContentByEntity(nameOriginal, positive, negative, neutral) {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      if (this.selectedEntity == "Person") {
        this.nerPersonSearch = JSON.stringify(nameOriginal);
      } else if (this.selectedEntity == "Organization") {
        this.nerOrganizationSearch = JSON.stringify(nameOriginal);
      } else {
        this.nerLocationSearch = JSON.stringify(nameOriginal);
      }

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const countAll = negative + neutral + positive;
        const beritaNegativePersen = negative / countAll * 100;
        this.beritaNegativePersen = parseFloat(beritaNegativePersen.toFixed(2));
        this.beritaNegative = negative;

        const beritaNetralPersen = neutral / countAll * 100;
        this.beritaNetralPersen = parseFloat(beritaNetralPersen.toFixed(2));
        this.beritaNetral = neutral;

        const beritaPositivePersen = positive / countAll * 100;
        this.beritaPositivePersen = parseFloat(beritaPositivePersen.toFixed(2));
        this.beritaPositive = positive;

        this.pageLengthPositive = Math.ceil(positive / this.pageplay);
        this.pageLengthNetral = Math.ceil(neutral / this.pageplay);
        this.pageLengthNegative = Math.ceil(negative / this.pageplay);

        if (isNaN(beritaPositivePersen)) {
          this.beritaPositivePersen = 0;
        }
        if (isNaN(beritaNetralPersen)) {
          this.beritaNetralPersen = 0;
        }
        if (isNaN(beritaNegativePersen)) {
          this.beritaNegativePersen = 0;
        }

        let maxSentiment = Math.max(this.beritaPositive, this.beritaNetral, this.beritaNegative);

        if (maxSentiment == this.beritaPositive) {
          this.selectedTab = 0;
          this.tabsSentiment = "Positive";
        } else if (maxSentiment == this.beritaNetral) {
          this.selectedTab = 1;
          this.tabsSentiment = "Neutral";
        } else {
          this.selectedTab = 2;
          this.tabsSentiment = "Negative";
        }
      } catch(e) {
        console.log(e);
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Media Chart Response Data Not Found";
        this.colorAlert = "red";
      }

      this.loadContent();
    },
    async loadContent() {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;
      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const keywordRequestValue = encodeKeywordRequest("", this.topicKeywordSentiment);

        const dataContent = await axios.post(
          `media-share-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${this.tabsSentiment}&start=0&rows=${this.pageplay}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&ner_location=${this.nerLocationSearch}&portal=${this.selectedPortal}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data = decryptionData(dataContent.data.data.data_content);

        this.kontenBeritaPositive = [];
        this.kontenBeritaNetral = [];
        this.kontenBeritaNegative = [];
        const content = data;

        content.forEach(item => {
          if (item.sentiment__s.toLowerCase() == "positive") {
            this.kontenBeritaPositive.push(item);
          }
          if (item.sentiment__s.toLowerCase() == "neutral") {
            this.kontenBeritaNetral.push(item);
          }
          if (item.sentiment__s.toLowerCase() == "negative") {
            this.kontenBeritaNegative.push(item);
          }
        });

        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      } catch(e) {
        console.log(e);
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Media Share Content Response Data Not Found";
        this.colorAlert = "red";
      }

      if (this.isSearch == true) {
        this.openDialogSearchContext();
      }

      this.isSearch = false;
    },
    getPrsImage(domain) {
      const found = this.listPrsImageDomain.find(item => item.DOMAIN == domain);
      return found ? found.PRS_IMAGE : "";
    },
    async contentListSentiment(sentiment) {
      this.tabsSentiment = sentiment;
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      const authToken = localStorage.getItem("token_app");
      if (!authToken) {
        throw new Error("Auth token not found");
      }

      const keywordRequestValue = encodeKeywordRequest("", this.topicKeywordSentiment);

      try {
        const dataContent = await axios.post(
          `media-share-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${sentiment}&start=0&rows=${this.pageplay}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&ner_location=${this.nerLocationSearch}&portal=${this.selectedPortal}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data = decryptionData(dataContent.data.data.data_content);
        this.kontenBeritaPositive = [];
        this.kontenBeritaNetral = [];
        this.kontenBeritaNegative = [];
        const content = data;

        content.forEach(item => {
          if (item.sentiment__s.toLowerCase() == "positive") {
            this.kontenBeritaPositive.push(item);
          }
          if (item.sentiment__s.toLowerCase() == "neutral") {
            this.kontenBeritaNetral.push(item);
          }
          if (item.sentiment__s.toLowerCase() == "negative") {
            this.kontenBeritaNegative.push(item);
          }
        });
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      } catch(e) {
        console.log(e);
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "Data Not Found";
        this.colorAlert = "red";
      }
    },
    async handlePageChangePositive(value) {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      const startPage = this.pageplay * (value - 1);

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const keywordRequestValue = encodeKeywordRequest("", this.topicKeywordSentiment);

        const dataContent = await axios.post(
          `media-share-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${this.tabsSentiment}&start=${startPage}&rows=${this.pageplay}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&ner_location=${this.nerLocationSearch}&portal=${this.selectedPortal}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data = decryptionData(dataContent.data.data.data_content);
        this.kontenBeritaPositive = [];
        for (let i = 0; i < data.length; i++) {
          if (data[i].sentiment__s.toLowerCase() == "positive") {
            this.kontenBeritaPositive.push(data[i]);
          }
        }

        setTimeout(() => {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
        }, 1000);
      } catch (e) {
        console.log(e);
        setTimeout(() => {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
        }, 1000);
      }
    },
    async handlePageChangeNetral(value) {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      const startPage = this.pageplay * (value - 1);

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const keywordRequestValue = encodeKeywordRequest("", this.topicKeywordSentiment);

        const dataContent = await axios.post(
          `media-share-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${this.tabsSentiment}&start=${startPage}&rows=${this.pageplay}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&ner_location=${this.nerLocationSearch}&portal=${this.selectedPortal}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data = decryptionData(dataContent.data.data.data_content);
        this.kontenBeritaNetral = [];
        for (let i = 0; i < data.length; i++) {
          if (data[i].sentiment__s.toLowerCase() == "neutral") {
            this.kontenBeritaNetral.push(data[i]);
          }
        }

        setTimeout(() => {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
        }, 1000);
      } catch (e) {
        console.log(e);
        setTimeout(() => {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
        }, 1000);
      }
    },
    async handlePageChangeNegative(value) {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      const startPage = this.pageplay * (value - 1);

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const keywordRequestValue = encodeKeywordRequest("", this.topicKeywordSentiment);

        const dataContent = await axios.post(
          `media-share-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${this.tabsSentiment}&start=${startPage}&rows=${this.pageplay}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&ner_location=${this.nerLocationSearch}&portal=${this.selectedPortal}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data = decryptionData(dataContent.data.data.data_content);
        this.kontenBeritaNegative = [];
        for (let i = 0; i < data.length; i++) {
          if (data[i].sentiment__s.toLowerCase() == "negative") {
            this.kontenBeritaNegative.push(data[i]);
          }
        }

        setTimeout(() => {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
        }, 1000);
      } catch (e) {
        console.log(e);
        setTimeout(() => {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
        }, 1000);
      }
    },
  }
}
</script>

<style scoped>
.custom-date-picker ::v-deep .v-date-picker-table button {
  color: #000000 !important;
}

.custom-date-picker ::v-deep .v-date-picker-table button.v-btn--active {
  background-color: var(--color-theme) !important;
  color: #ffffff !important;
}

.rotate-animation {
  animation: rotateFrom90 1s linear;
}

@keyframes rotateFrom90 {
  from {
    transform: rotate(90deg);
  }
  to {
    transform: rotate(-450deg);
  }
}

.loading-dots {
  color: var(--color-theme);
  font-size: 32px;
  font-weight: bold;
  display: inline-flex;
}

.loading-dots span {
  animation: blink 1.5s infinite;
  margin: 0 2px;
}

.loading-dots span:nth-child(1) { animation-delay: 0s; }
.loading-dots span:nth-child(2) { animation-delay: 0.2s; }
.loading-dots span:nth-child(3) { animation-delay: 0.4s; }

@keyframes blink {
  0% { opacity: 0.2; }
  50% { opacity: 1; }
  100% { opacity: 0.2; }
}

.response-textdescribedashboard {
  background: #f4f4f4;
  color: #2e2e2e;
  display: block;
  overflow-x: auto;
  max-height: 100%;
  max-width: 100%;
  border-radius: 8px;
  line-height: 1.6;
  padding: 10px;
}

.response-textdescribedashboard strong {
  display: block;
  margin-bottom: 4px;
}

.response-textdescribedashboard ul {
  margin-top: 4px;
  padding-left: 20px;
}

.btn-close-dialog-search-context {
  position: absolute;
  top: 5px;
  right: 5px;
  color: white;
  margin-left: auto;
}

.confirm-reset {
  position: absolute; top: 10px; right: 10px;
}

div.apexcharts-canvas.apexcharts-theme-dark {
  background: transparent !important;
}

::v-deep .apexcharts-toolbar,
::v-deep .apexcharts-menu {
  z-index: 1 !important;
}

.tooltip .tooltip-inner {
  max-width: 100px !important;
  width: 100px !important;
}

.v-tooltip__content {
  font-size: 12px !important;
  max-width: 150px;
}

.tooltip-entity-bubble {
  position: fixed;
  background: white !important;
  color: black;
  pointer-events: none;
  width: 240px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  font-size: 14px;
  line-height: 1.4;
  padding: 10px;
  z-index: 9999;
}

.bubble-container {
  position: relative;
  height: 400px;
  width: 400px;
  margin: 0 auto;
}

.bubble {
  position: absolute;
  overflow: hidden;
  border-radius: 50%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s;
}

.bubble:hover {
  transform: scale(1.1);
  z-index: 2;
}

.bubble-image {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.card-container {
  margin: 0 auto;
  padding: 1rem;
}

.overflow-card {
  overflow-y: auto;
  overflow-x: hidden;
}

.content-list-card {
  background: #FFF;
  border: 0.6px solid #E4E4E4;
  border-radius: 8px;
}

.content-list-card:hover {
  background: #FFF;
  border: 0.6px solid #E4E4E4;
  border-radius: 8px;
  box-shadow: 3px 5px 7px 0px #E4E4E4 !important;
}

.v-avatar.color-avatar-berita-online {
  background-image:
  linear-gradient(to right top, #53d166, #5dd468, #65d769, #6eda6b, #76dd6d, #7ee06f, #86e271, #8de573, #96e876, #9fec79, #a8ef7c, #b1f27f);
}

.v-pagination {
  z-index: 10 !important;
  position: relative;
}
</style>
